import { useEffect } from 'react';

/**
 * Triggers: `company` (the watched company id).
 * Writes:   nothing in the form — reports the id to the Provider gate, which re-reads
 *           that company's settings and swaps the schema. A superseded read is aborted.
 * Guards:   none; defaults are never re-seeded, so user edits survive the switch.
 * Legacy:   none.
 * Test:     __tests__/OrderFormV3Context.test.tsx ("record company settings").
 *
 * Called by the effects/OrderFormV3Effects.tsx host, which runs every effect
 * module in one fixed, explicit order.
 */
export function useRecordCompanySettingsSync({
  watchedCompanyId,
  onRecordCompanyIdChange,
}: {
  watchedCompanyId: string | undefined;
  onRecordCompanyIdChange: (companyId: string | undefined) => void;
}): void {
  useEffect(() => {
    onRecordCompanyIdChange(watchedCompanyId);
  }, [watchedCompanyId, onRecordCompanyIdChange]);
}
